export default "__VITE_ASSET__CVarfzGS__"